module.exports = __webpack_public_path__ + "img/slide-1-mobile-min.625a24c4.jpg";